import React, { useMemo } from "react";

import {
  createFormatterForProfileTypeWithItemsSuffix,
  getProfileTypeTitle,
  ProfileTypeAggregations
} from "@platformsh/observability-graph/ContinuousProfiling";
import { BaseFormatter } from "@platformsh/observability-graph/Formatter";
import { useIntl } from "react-intl";

import todayOrYesterday from "Libs/datetime";
import Tooltip from "src/organization/pages/project/environment/metrics/http/components/tooltip";
import {
  Table,
  TableRow,
  Td
} from "src/organization/pages/project/environment/metrics/http/components/tooltip/style";

import useConprofContext from "../hooks/useConprofContext";
import ProfileTypeBullet from "../ProfileTypeBullet";

import * as S from "./TimelineTooltip.style";

type TimelineTooltipProps = {
  enabled?: boolean;
};

const TimelineTooltip = ({ enabled }: TimelineTooltipProps) => {
  const { cursorData, data } = useConprofContext();
  const profileType = data?.profileType;
  const intl = useIntl();

  const formatter: BaseFormatter = useMemo(
    () =>
      profileType
        ? createFormatterForProfileTypeWithItemsSuffix(profileType)
        : new BaseFormatter(),
    [profileType]
  );
  const { absoluteX, absoluteY, indexedData, xInvert } = cursorData || {};
  if (!cursorData || !profileType) {
    return null;
  }

  return (
    <Tooltip
      isVisible={enabled && indexedData.value !== undefined}
      x={absoluteX}
      y={absoluteY}
    >
      <Table>
        <tbody>
          <TableRow>
            <S.TdTitle colSpan={3}>{todayOrYesterday(xInvert)}</S.TdTitle>
          </TableRow>
          <TableRow>
            <S.TdKey>
              <ProfileTypeBullet profileTypeName={profileType.name} />
            </S.TdKey>
            <Td>{formatter.toCondensedString(indexedData.value)}</Td>
            <Td>
              {getProfileTypeTitle(profileType.name)}
              {profileType?.aggregation === ProfileTypeAggregations.SUM && (
                <>
                  {" - "}
                  {intl.formatMessage({
                    id: "conprof.profile_type.rate"
                  })}
                </>
              )}
            </Td>
          </TableRow>
        </tbody>
      </Table>
    </Tooltip>
  );
};

export default TimelineTooltip;
